import React, { useState } from "react";

import { Navigation, A11y, EffectCoverflow, Pagination } from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";
// import "./ReviewComponent.scss";
import "swiper/css";
import "swiper/css/navigation";
import SearchOfferTemplatesReq from "../../../Requests/OfferTemplate/SearchOfferTemplatesReq";
import OfferApi from "../../../API/OfferApi";
import Swal from "sweetalert2";
import { useEffect } from "react";
import UserSelector from "../../../components/UserSelector"; // Assuming this is the component you're using for selecting sales reps
import { MdDelete } from "react-icons/md";
import StringIntReq from "../../../Requests/StringIntReq";

const AddRepTemplate = ({ company }) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [offers, setOffers] = useState([]);
  const [id, setId] = useState("");
  const [selectedRep, setSelectedRep] = useState(null);
  const [assigned, setAssigned] = useState([]);

  const AddRepToOfferTemplate = async () => {
    if (!selectedRep) {
      Swal.fire({
        icon: "error",
        title: "Sales Rep is required",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      return;
    }
    if (!id) {
      Swal.fire({
        icon: "error",
        title: "Offer Template is required",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      return;
    }
    let req = {
      offerTemplateId: id,
      userId: selectedRep,
    };
    let res = await OfferApi.CreateOfferTemplateUser(req);
    if (res?.status?.success) {
      Swal.fire({
        icon: "success",
        title: "Sales Rep Added Successfully",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      setSelectedRep(null);
      searchOfferTemplate();
    } else {
      Swal.fire({
        icon: "error",
        title: "Failed to Add Sales Rep",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    }
  };

  const removeFiberPlan = async (id) => {
    let req = new StringIntReq();
    req.Int = id;

    let res = await OfferApi.DeleteOfferTemplateUser(req);
    if (res?.status?.success) {
      Swal.fire({
        icon: "success",
        title: "Fiber Plan Removed Successfully",
        customClass: {
          container: "custom-swal",
        },

        didOpen: () => {
          Swal.hideLoading();
        },
      });
      searchOfferTemplate();
    } else {
      Swal.fire({
        icon: "error",
        title: "Failed to Remove Fiber Plan",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    }
  };

  const searchOfferTemplate = async () => {
    const req = new SearchOfferTemplatesReq();
    req.fiberCompanyId = company.id;
    const res = await OfferApi.SearchOfferTemplate(req);

    if (res?.status?.success) {
      setOffers(res?.data);
      setId(res?.data[0]?.id);
    } else {
      Swal.fire({
        icon: "error",
        title: "Failed to fetch Offer Template",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    }
  };

  const searchAssignedReps = async () => {
    const req = new SearchOfferTemplatesReq();
    req.fiberCompanyId = company.id;

    const res = await OfferApi.SearchOfferTemplate(req);
    if (res?.status?.success) {
      setAssigned(res?.data);
    } else {
      Swal.fire({
        icon: "error",
        title: "Failed to fetch Offer Template",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    }
  };
  console.log("assigned: ", assigned);

  useEffect(() => {
    searchAssignedReps();
  }, [company]);

  useEffect(() => {
    if (company) searchOfferTemplate();
  }, [company]);
  return (
    <div className="add_plan_to_template overflow-x-hidden  ">
      <h1> Assign Reps To Offer Template </h1>

      <div className=" max-x[100vw] overflow-hidden ">
        <Swiper
          modules={[Navigation, A11y, EffectCoverflow, Pagination]}
          spaceBetween={5}
          slidesPerView={3} // Dynamically adjust slidesPerView
          navigation={true}
          // pagination={{
          //   clickable: true,
          // }}
          scrollbar={{ draggable: true }}
          onSwiper={(swiper) => console.log(swiper)}
          onSlideChange={(swiper) => {
            if (swiper.isEnd) {
              setPageNumber(pageNumber + 1);
            }
          }}
        >
          <div className="flex items-center ">
            {offers.map((offer) => {
              return (
                <SwiperSlide key={offer.id}>
                  <div
                    onClick={() => {
                      setId(offer.id);
                    }}
                    className={`flex p-4 border  rounded-md justify-center items-center cursor-pointer ${
                      offer.id === id ? " border-blue-400" : "border-gray-300"
                    }`}
                  >
                    <p>{offer.name}</p>
                  </div>
                </SwiperSlide>
              );
            })}
          </div>
        </Swiper>
      </div>

      <div className="form">
        <UserSelector
          setUser={setSelectedRep}
          conversationType={"Private"}
          placeholder="Select Sales Representative"
        />

        {selectedRep && (
          <button
            onClick={() => {
              AddRepToOfferTemplate();
            }}
            className="add-btn"
          >
            Add Sales Rep
          </button>
        )}
      </div>

      <div className="fiber_plans">
        {offers
          ?.find((x) => x.id == id)
          ?.offerTemplateUsers?.map((item) => {
            return (
              <div className="fiber_plan" key={item.id}>
                <p>{item.user?.firstName + " " + item.user?.lastName}</p>              

                <button
                  onClick={() => {
                    removeFiberPlan(item.id);
                  }}
                >
                  <MdDelete color="white" size={30} />
                </button>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default AddRepTemplate;
